// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17uAy","type":"styles_type__1p0-x","choices":"styles_choices__1xzMA"};